import { render } from "./ConfirmEmail.vue?vue&type=template&id=7f35add1&scoped=true"
import script from "./ConfirmEmail.vue?vue&type=script&lang=js"
export * from "./ConfirmEmail.vue?vue&type=script&lang=js"

import "./ConfirmEmail.vue?vue&type=style&index=0&id=7f35add1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f35add1"]])

export default __exports__